import type { InputHTMLAttributes } from "react";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
    checked: boolean;
}

export default function Checkbox({ checked, className = "", ...rest }: CheckboxProps) {
    return (
        <input
            type="checkbox"
            checked={checked}
            className={`border-dark-border bg-dark-surface-elevated rounded text-teal-600 shadow-sm focus:ring-teal-500 ${className}`}
            {...rest}
        />
    );
}
